import { createServerFn } from "@tanstack/react-start";

export const fetchBestList = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) => data)
  .handler(async ({ data }) => {
    const { setResponseHeader } = await import("@tanstack/react-start/server");
    setResponseHeader(
      "cache-control",
      "public, max-age=300, stale-while-revalidate=3600",
    );
    const { getBestList } = await import("./library-best.server");
    return getBestList(data.slug);
  });
